export default __webpack_public_path__ + "static/media/performance.205146c4.svg";